/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export var ThemedComponent;
(function (ThemedComponent) {
    ThemedComponent["SPLASH_SCREEN"] = "splash-screen";
    ThemedComponent["SHELL_BANNER_ALERTS"] = "shell.banner-alerts";
    ThemedComponent["SHELL_DIALOGS"] = "shell.dialogs";
    ThemedComponent["SHELL_TOASTS"] = "shell.toasts";
    ThemedComponent["SHELL_PROGRESS_INDICATORS_NONBLOCKING"] = "shell.progress-indicators.non-blocking";
    ThemedComponent["SHELL_PROGRESS_INDICATORS_BLOCKING"] = "shell.progress-indicators.blocking";
    ThemedComponent["SHELL_SKIP_TO_CONTENT"] = "shell.skip-to-content";
    ThemedComponent["SHELL_SITE_COLOR_PALETTE"] = "shell.site-color-palette";
    ThemedComponent["SHELL_ERROR_PAGES"] = "shell.error-pages";
    ThemedComponent["SHELL_CUSTOM_OVERLAYS"] = "shell.custom-overlays";
    ThemedComponent["SHELL_SLIM_HEADER"] = "shell.slim-header";
    ThemedComponent["SHELL_SLIM_FOOTER"] = "shell.slim-footer";
    ThemedComponent["SHELL_FULL_SCREEN_DEFAULT_PAGE"] = "shell.full-screen-default-page";
    ThemedComponent["SHELL_DEFAULT_PAGE"] = "shell.default-page";
    ThemedComponent["SHELL_HEADER_SKELETON"] = "shell.header-skeleton.skeleton";
    ThemedComponent["SHELL_NAVBAR_SKELETON"] = "shell.navbar-skeleton.skeleton";
    ThemedComponent["SHELL_QUICKNAV_SKELETON"] = "shell.quicknav-skeleton.skeleton";
    ThemedComponent["SHELL_CONTENT_SKELETON"] = "shell.content-skeleton.skeleton";
    ThemedComponent["SHELL_FOOTER_SKELETON"] = "shell.footer-skeleton.skeleton";
    ThemedComponent["HEADER"] = "header";
    ThemedComponent["NAVBAR"] = "navbar";
    ThemedComponent["QUICKNAV"] = "quicknav";
    ThemedComponent["CONTENT"] = "content";
    ThemedComponent["FOOTER"] = "footer";
})(ThemedComponent || (ThemedComponent = {}));
export class ThemedComponents {
}
ThemedComponents.ALL = [
    ThemedComponent.SPLASH_SCREEN,
    ThemedComponent.SHELL_BANNER_ALERTS,
    ThemedComponent.SHELL_DIALOGS,
    ThemedComponent.SHELL_TOASTS,
    ThemedComponent.SHELL_PROGRESS_INDICATORS_NONBLOCKING,
    ThemedComponent.SHELL_PROGRESS_INDICATORS_BLOCKING,
    ThemedComponent.SHELL_SKIP_TO_CONTENT,
    ThemedComponent.SHELL_ERROR_PAGES,
    ThemedComponent.SHELL_CUSTOM_OVERLAYS,
    ThemedComponent.SHELL_SLIM_HEADER,
    ThemedComponent.SHELL_SLIM_FOOTER,
    ThemedComponent.SHELL_FULL_SCREEN_DEFAULT_PAGE,
    ThemedComponent.SHELL_DEFAULT_PAGE,
    ThemedComponent.SHELL_HEADER_SKELETON,
    ThemedComponent.SHELL_NAVBAR_SKELETON,
    ThemedComponent.SHELL_QUICKNAV_SKELETON,
    ThemedComponent.SHELL_CONTENT_SKELETON,
    ThemedComponent.SHELL_FOOTER_SKELETON,
    ThemedComponent.HEADER,
    ThemedComponent.NAVBAR,
    ThemedComponent.QUICKNAV,
    ThemedComponent.CONTENT,
    ThemedComponent.FOOTER,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWFibGUtY29tcG9uZW50cy5jb25zdGFudHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2hhcmVkL3RoZW1pbmcvdGhlbWFibGUtY29tcG9uZW50cy5jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLENBQU4sSUFBWSxlQXlCWDtBQXpCRCxXQUFZLGVBQWU7SUFDdkIsa0RBQStCLENBQUE7SUFDL0IsOERBQTJDLENBQUE7SUFDM0Msa0RBQStCLENBQUE7SUFDL0IsZ0RBQTZCLENBQUE7SUFDN0IsbUdBQWdGLENBQUE7SUFDaEYsNEZBQXlFLENBQUE7SUFDekUsa0VBQStDLENBQUE7SUFDL0Msd0VBQXFELENBQUE7SUFDckQsMERBQXVDLENBQUE7SUFDdkMsa0VBQStDLENBQUE7SUFDL0MsMERBQXVDLENBQUE7SUFDdkMsMERBQXVDLENBQUE7SUFDdkMsb0ZBQWlFLENBQUE7SUFDakUsNERBQXlDLENBQUE7SUFDekMsMkVBQXdELENBQUE7SUFDeEQsMkVBQXdELENBQUE7SUFDeEQsK0VBQTRELENBQUE7SUFDNUQsNkVBQTBELENBQUE7SUFDMUQsMkVBQXdELENBQUE7SUFDeEQsb0NBQWlCLENBQUE7SUFDakIsb0NBQWlCLENBQUE7SUFDakIsd0NBQXFCLENBQUE7SUFDckIsc0NBQW1CLENBQUE7SUFDbkIsb0NBQWlCLENBQUE7QUFDckIsQ0FBQyxFQXpCVyxlQUFlLEtBQWYsZUFBZSxRQXlCMUI7QUFFRCxNQUFNLE9BQU8sZ0JBQWdCOztBQUNYLG9CQUFHLEdBQUc7SUFDaEIsZUFBZSxDQUFDLGFBQWE7SUFDN0IsZUFBZSxDQUFDLG1CQUFtQjtJQUNuQyxlQUFlLENBQUMsYUFBYTtJQUM3QixlQUFlLENBQUMsWUFBWTtJQUM1QixlQUFlLENBQUMscUNBQXFDO0lBQ3JELGVBQWUsQ0FBQyxrQ0FBa0M7SUFDbEQsZUFBZSxDQUFDLHFCQUFxQjtJQUNyQyxlQUFlLENBQUMsaUJBQWlCO0lBQ2pDLGVBQWUsQ0FBQyxxQkFBcUI7SUFDckMsZUFBZSxDQUFDLGlCQUFpQjtJQUNqQyxlQUFlLENBQUMsaUJBQWlCO0lBQ2pDLGVBQWUsQ0FBQyw4QkFBOEI7SUFDOUMsZUFBZSxDQUFDLGtCQUFrQjtJQUNsQyxlQUFlLENBQUMscUJBQXFCO0lBQ3JDLGVBQWUsQ0FBQyxxQkFBcUI7SUFDckMsZUFBZSxDQUFDLHVCQUF1QjtJQUN2QyxlQUFlLENBQUMsc0JBQXNCO0lBQ3RDLGVBQWUsQ0FBQyxxQkFBcUI7SUFDckMsZUFBZSxDQUFDLE1BQU07SUFDdEIsZUFBZSxDQUFDLE1BQU07SUFDdEIsZUFBZSxDQUFDLFFBQVE7SUFDeEIsZUFBZSxDQUFDLE9BQU87SUFDdkIsZUFBZSxDQUFDLE1BQU07Q0FDekIsQ0FBQyJ9